/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum FinalizarRepasseAliases {
  CARD_0 = 'card-0',
  DATE_FIELD = 'date-field',
  DATE_LIBERACAO = 'date-liberacao',
  DATEFIELD_DATA_FIM_REPASSE = 'datefield-data-fim-repasse',
  FETCH_0 = 'fetch-0',
  FIELD_DATA_FIM_REPASSE = 'field-data-fim-repasse',
  FIELD_DATA_LIBERACAO = 'field-data-liberacao',
  FIELD_DATA_REPASSE = 'field-data-repasse',
  FIELD_LOCAL_ATENDIMENTO = 'field-local-atendimento',
  FIELD_TIPO_REPASSE = 'field-tipo-repasse',
  FIELD_TOAST = 'field-toast',
  FORM_FINALIZAR_REPASSE = 'form-finalizar-repasse',
  MAPPER_2 = 'mapper-2',
  PANEL_0 = 'panel-0',
  PANEL_FINALIZAR_REPASSE = 'panel-finalizar-repasse',
  TEXT_LOCAL_ATENDIMENTO = 'text-local-atendimento',
  TEXT_TIPO_REPASSE = 'text-tipo-repasse',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { FinalizarRepasseAliases };
